import api from './api';

const faqService = {
  // ============ Section Operations ============

  // Get all sections with their questions
  getSections: () => {
    return api.get('/api/admin/faq/sections');
  },

  // Get single section by ID
  getSection: (id) => {
    return api.get(`/api/admin/faq/sections/${id}`);
  },

  // Create new section
  createSection: (data) => {
    return api.post('/api/admin/faq/sections', data);
  },

  // Update section
  updateSection: (id, data) => {
    return api.put(`/api/admin/faq/sections/${id}`, data);
  },

  // Delete section (cascades to questions)
  deleteSection: (id) => {
    return api.delete(`/api/admin/faq/sections/${id}`);
  },

  // ============ Question Operations ============

  // Get all questions for a section
  getQuestions: (sectionId) => {
    return api.get(`/api/admin/faq/sections/${sectionId}/questions`);
  },

  // Get single question by ID
  getQuestion: (id) => {
    return api.get(`/api/admin/faq/questions/${id}`);
  },

  // Add question to section
  addQuestion: (sectionId, data) => {
    return api.post(`/api/admin/faq/sections/${sectionId}/questions`, data);
  },

  // Update question
  updateQuestion: (id, data) => {
    return api.put(`/api/admin/faq/questions/${id}`, data);
  },

  // Delete question
  deleteQuestion: (id) => {
    return api.delete(`/api/admin/faq/questions/${id}`);
  },
};

export default faqService;
